export default "__VITE_ASSET__b72652c6__"